import styled from "styled-components";

export const CreateChannelHeader = styled.h3``;
